import useDatadogSetViewContext from '@/utils/useDatadogSetViewContext';
import { Toaster } from '@parentsquare/squarekit/components/ui/sonner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { RouterProvider } from 'react-router/dom';

import { router } from '@/routes/router';

const queryClient = new QueryClient();

const App = (): React.ReactNode => {
  useDatadogSetViewContext();

  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <div data-turbolinks="false">
          <Toaster toastOptions={{ duration: 5000 }} />
          <RouterProvider router={router} />
        </div>
      </QueryClientProvider>
    </React.StrictMode>
  );
};

export default App;
